import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import ShowMoreButton from "../../atoms/ShowMoreButton";
import { generateNavigateSlug, navigateTo } from "../../utils";
import { DfpComponent } from "../../ads/dfp-component";
import StoryCard from "./StoryCard";

import "./two-col-two.m.css";

export default function TwoColumnTwoStories({ config = {}, collection, stories, extraProp = "" }) {
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const enableSponsorAd = associatedMetadata.enable_sponsor_ad || null;
  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const showRowSeparator = associatedMetadata.show_row_separator || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  const rowAdUnitBottom = associatedMetadata.show_row_ad_unit_bottom || null;
  const showRowTitle = associatedMetadata.show_row_title || null;
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const sponsorAdDetails = associatedMetadata.sponsor_ad_details || null;
  const showSubHeadline = associatedMetadata.show_sub_headline || null;
  const showMoreStories = associatedMetadata.show_more_stories || null;

  const dispatch = useDispatch();
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const url = generateNavigateSlug(collection, qtConfig);

  const rowAdBottom = rowAdUnitBottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  if (stories.length === 0) return null;
  return (
    <div className="row-component" styleName="top-component-wrapper">
      <div styleName="two-col-two-stories">
        {showRowTitle && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enableSponsorAd}
            sponsorAdDetails={sponsorAdDetails}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
          />
        )}
        <div styleName={`${showColumnSeparator ? "story-list-with-seperator" : "story-list"}`}>
          {stories.map((story, index) => (
            <Fragment key={index}>
              <StoryCard
                story={story}
                showTimeStamp={showTimeStamp}
                showReadTime={showReadTime}
                showSubHeadline={showSubHeadline}
                sectionSlug={sectionSlug}
              />
              {showColumnSeparator && index !== stories.length - 1 && <div styleName="divider"></div>}
            </Fragment>
          ))}
        </div>
        {showMoreStories && (
          <ShowMoreButton
            collection={collection}
            config={config}
            navigate={() => navigateTo(dispatch, url)}
            qtConfig={qtConfig}
          />
        )}
      </div>
      {showRowSeparator && <RowSeparator />}
      {rowAdUnitBottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
}

TwoColumnTwoStories.propTypes = {
  config: PropTypes.object,
  collection: PropTypes.object.isRequired,
  stories: PropTypes.array.isRequired,
  extraProp: PropTypes.string,
};

TwoColumnTwoStories.storyLimit = 2;
